// extracted by mini-css-extract-plugin
module.exports = {"button":"button-blue-icon_button_3_TlE","disabled":"button-blue-icon_disabled_eE4HF"};